export const step1 = {
  policyData: 'DADOS DA APÓLICE',
  initialDate: 'Data de Início',
  simulate: 'SIMULAR',
  nextTab: 'Avançar',
  vatNumber: 'NIF do Tomador',
  selectEntity: 'Selecionar Entidade',
  selectEntityPerson: 'Escolha a pessoa pretendida',
  mandatory: '* Campo de preenchimento obrigatório',
  animalInsuranceTable: {
    title: 'Identificação de Animais Seguros',
    addAnimal: 'ADICIONAR NOVO ANIMAL SEGURO',
    tab: {
      tooltip: 'Existem campos obrigatórios',
      generalData: 'Dados Gerais',
      questionnaires: 'Questionários',
    },
  },
  animalInputData: {
    name: 'Nome do animal',
    birthdate: 'Data de Nascimento*',
    birthdateError: 'Data de Nascimento inválida*',
    species: 'Espécie*',
    breed: 'Raça*',
  },
  createAddress: {
    confirm: 'Confirmar',
    ownerAddress: 'Morada do Animal',
  },
  errors: {
    notFoundEntity: 'Não foram encontradas entidades para o NIF indicado',
    validateData: 'Verifique se os dados foram preenchidos corretamente',
    questionnaires:
      'Preencha os dados dos animais e o questionário corretamente',
    mandatoryField: 'Campo de preenchimento obrigatório',
    invalidZipCode:
      'Não foram encontrados resultados para o Código Postal introduzido',
  },
  addressAnimalValidate:
    'Morada do Animal maior que 50 caracteres: <br /><b><i>%{address}<br />(%{number} caracteres)</i></b>',
  addressEntityValidate:
    'Morada da entidade maior que 50 caracteres: <br /><b><i>%{address}<br />(%{number} caracteres)</i></b>',
  breedDangerousMessage:
    'Para animais de raça potencialmente perigosa e animais em que pelo menos um dos progenitores é de raça potencialmente perigosa é necessário anexar a seguinte documentação ao contrato: Termo de Responsabilidade, conforme modelo anexo ao DL 312/2009 de 17 de Dezembro, e cópia do Registo Criminal do Detentor do Animal.',
}
